package uz.ferro.erp.icon

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import web.cssom.Cursor
import web.cssom.px

fun SvgUrlIcon(
    url: String,
    size: Int = 20,
    width: Int = size,
    height: Int = size,
    clickAction: (() -> Unit)? = null
): FC<Props> = FC {
    ReactHTML.img {
        src = url
        css {
            this.width = width.px
            this.height = height.px
            if (clickAction != null) {
                cursor = Cursor.pointer
            }
        }

        if (clickAction != null) {
            onClick = {
                clickAction()
                it.preventDefault()
                it.stopPropagation()
            }
        }
    }
}

external interface SvgIconViewProps : Props {
    var url: String
    var size: Int?
    var width: Int?
    var height: Int?
    var onClick: (() -> Unit)?
}

val SvgIconView = FC<SvgIconViewProps> { props ->
    ReactHTML.img {
        src = props.url
        css {
            this.width = (props.width ?: props.size ?: 20).px
            this.height = (props.height ?: props.size ?: 20).px
            if (props.onClick != null) {
                cursor = Cursor.pointer
            }
        }

        if (props.onClick != null) {
            onClick = {
                props.onClick?.invoke()
            }
        }
    }
}